import { dashboard } from "@/utils/constants";
import { handleError, handleResponse } from "@/utils/functions";

export default (axios) => ({
  getDashboardStatistics(params) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${dashboard.base}statistics/`, { params: params })
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getDashboardTripsRoutes(params) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${dashboard.base}trips_and_route_chart/`, { params: params })
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
});
